export const SUGGESTED_INITIAL_LIMIT = 4;
export const SUGGESTED_PAGE_SIZE = 25;

export interface SuggestedEvidencesPageResponse {
  evidences: any[];
  totalCount?: number;
  hasMore?: boolean;
  weeks?: string[];
  quarters?: string[];
  months?: string[];
  computedStatus?: string;
}

export const computeSuggestedHasMore = (
  skip: number,
  pageSize: number,
  totalCount: number
): boolean => skip + pageSize < totalCount;

export const getSuggestedNextPageSkip = (
  loadedCount: number,
  isInitialPage: boolean
): number => (isInitialPage ? SUGGESTED_INITIAL_LIMIT : loadedCount);

export const getSuggestedPageLimit = (isInitialPage: boolean): number =>
  isInitialPage ? SUGGESTED_INITIAL_LIMIT : SUGGESTED_PAGE_SIZE;
